import { getProviderLicensesStatus, postProviderStatesSelection } from '@uplift/api';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { providerQueryKeys } from './providerQueryKeys';

export const useProviderLicensesStatusQuery = (providerId: string) => {
  return useQuery({
    queryKey: providerQueryKeys.statesSelection(providerId),
    queryFn: async() => {
      const response = await getProviderLicensesStatus(providerId);

      return response.data;
    },
  });
};

export const useProviderStatesSelectionMutation = (providerId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: providerQueryKeys.statesSelection(providerId),
    mutationFn: async(args: { stateIds: string[]; setLive: boolean }) => {
      const response = await postProviderStatesSelection(providerId, args.stateIds, args.setLive);

      return response.data;
    },
    onSuccess() {
      queryClient.invalidateQueries(providerQueryKeys.statesSelection(providerId));
      queryClient.invalidateQueries(providerQueryKeys.licenses(providerId));
    },
  });
};
